import { __ } from "@wordpress/i18n";
import PropTypes from "prop-types";
import Constants from "../constants";

function NoDataMsg({
	showImage,
	showTitle,
	showMsg,
	showButton,
	buttonLink,
	buttonTarget,
	buttonLabel,
	title,
	msg,
	imageSrc,
	buttonStyleClasses,
	buttonRoundedStyle
}) {
	return (
		<div className="flex flex-col items-center justify-center no-data-msg">
			{showImage && (
				<img
					src={
						imageSrc !== "#"
							? imageSrc
							: wpApiSettings.bseit_assets_dir_url + "icons/404.svg"
					}
					className="object-cover w-72"
					alt=""
					loading="lazy"
				/>
			)}

			{showTitle && (
				<h3 className="pt-6 pb-2 text-xl font-bold text-center lg:text-4xl text-primary">
					{__(title, Constants.TEXT_DOMAIN)}
				</h3>
			)}

			{showMsg && (
				<p className="pb-6 text-center text-darkGray">
					{__(msg, Constants.TEXT_DOMAIN)}
				</p>
			)}

			{showButton && (
				<a href={buttonLink} target={buttonTarget} className={buttonStyleClasses + ' ' + buttonRoundedStyle}>
					{__(buttonLabel, Constants.TEXT_DOMAIN)}
				</a>
			)}
		</div>
	);
}

// TODO: Check props because its not working!
NoDataMsg.propTypes = {
	showTitle: PropTypes.bool,
	showImage: PropTypes.bool,
	showButton: PropTypes.bool,
	showMsg: PropTypes.bool,
	buttonLink: PropTypes.string,
	buttonTarget: PropTypes.string,
	buttonLabel: PropTypes.string,
	title: PropTypes.string,
	msg: PropTypes.string,
	imageSrc: PropTypes.string,
};
export default NoDataMsg;
